// extracted by mini-css-extract-plugin
export var stickyButton = "styles-module--stickyButton--yuSxV";
export var moreInfoContainer = "styles-module--moreInfoContainer--3aCkW";
export var contentContainer = "styles-module--contentContainer--3qrjT";
export var open = "styles-module--open--jjfox";
export var close = "styles-module--close--3rZOe";
export var show = "styles-module--show--iIERZ";
export var hide = "styles-module--hide--21AOy";